import apiClient from "./apiClient";
const API_URL = `/ipd-treatments`; // Use relative path since apiClient has baseURL

export const create = async (treatmentData) => {
  // apiClient will automatically add organizationId via interceptor
  const response = await apiClient.post(`${API_URL}/create`, treatmentData);
  return response.data;
};

export const getAssignedStaff = async (patientId) => {
  // apiClient will automatically add organizationId as query param via interceptor
  const response = await apiClient.get(`${API_URL}/assigned-staff/${patientId}`);
  return response.data;
};

export const getByAssignment = async (patientId) => {
  try {
    // apiClient will automatically add organizationId as query param via interceptor
    const response = await apiClient.get(`${API_URL}/assignment/${patientId}`);
    return response.data;
  } catch (error) {
    if (
      error.response?.status === 500 &&
      (error.response?.data?.message?.includes("Failed to retrieve") ||
        error.response?.data?.message?.includes("from table") ||
        error.response?.data?.message?.includes("does not exist"))
    ) {
      console.warn(
        "Organization-specific IPD treatments assignment table not found, returning empty array:",
        error.response.data?.message
      );
      return [];
    }
    throw error;
  }
};

export const getTreatmentsByAdmissionId = async (admissionId) => {
  try {
    // apiClient will automatically add organizationId as query param via interceptor
    const response = await apiClient.get(`${API_URL}/by-admission/${admissionId}`);
    return response.data;
  } catch (error) {
    if (
      error.response?.status === 500 &&
      (error.response?.data?.message?.includes("Failed to retrieve") ||
        error.response?.data?.message?.includes("from table") ||
        error.response?.data?.message?.includes("does not exist"))
    ) {
      console.warn(
        "Organization-specific IPD treatments table not found, returning empty array:",
        error.response.data?.message
      );
      return [];
    }
    throw error;
  }
};

export default { 
  create, 
  getAssignedStaff,
  getByAssignment,
  getTreatmentsByAdmissionId
}